import React from "react";
import { Link } from "react-router-dom";
import "./FooterNew.css";
import logo from "../../Assets/logo.svg";
import { Grid } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { InstagramIcon, SocialIcon, TwitterIcon } from "../../Icons/Icons";
import { GetSubcategories } from "../../client-api/APIcategory";
import { GetFooterlink, imagemain } from "../../client-api/ApiHome";
import { useFilterContext } from "../../Context/Filter_context_section";
import { useAuthContext } from "../../Context/AuthContext";
import useMediaQuery from "@mui/material/useMediaQuery";
import StraightIcon from "@mui/icons-material/Straight";
import { useTheme } from "@mui/material/styles";
import mastercard from "../../Assets/mmc-logo.svg";
import tamara from "../../Assets/Tamara.svg";
import visa from "../../Assets/visa.png";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
const Data = [
  {
    content: " Family Active Sports Equipment Trading LLC",
  },
  {
    content: "B62 Building, Office No 215,",
  },
  {
    content: "Riggat Al Buteen, Deira,",
  },
  {
    content: "Dubai, United Arab Emirates.",
  },
];
const Scocialmedia = [
  {
    SocialIcon: SocialIcon,
    link: "https://www.facebook.com/MyFamFitness/",
    socaltxt: "Facebook",
  },
  {
    SocialIcon: TwitterIcon,
    link: "https://twitter.com/myfamfitness/",
    socaltxt: "Twitter",
  },
  {
    SocialIcon: InstagramIcon,
    link: "https://www.instagram.com/myfamilyfitness/?utm_medium=copy_link",
    socaltxt: "Instagram",
  },
];

const Address = [
  { id: "footer_myfamily_bold", addresstxt: " Customer Support:" },
  { addresstxt: "  support@myfamilyfitness.com" },
  { addresstxt: "   +971 56 4127900 / 800-326459 (Toll Free)" },
  { id: "footer_myfamily_bold", addresstxt: " Sales/Service Enquiry:" },
  { addresstxt: "    sales@myfamilyfitness.com" },
  { addresstxt: " +971 4 548 1159 / 800-326459 (Toll Free)" },
];

const PayIcon = [
  {
    // src: "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/footer/mastercard.webp?updatedAt=1715237432241",
   src:mastercard,
    alt: "Master Card",
    height: "30",
    width: "150",
  },
  {
    src:visa,
    // src: "https://ik.imagekit.io/thmmwwbpc/MFF%20E%20Commerce/footer/visacard.webp?updatedAt=1715237432475",
    alt: "Visa",
    height: "20",
    width: "50",
  },
  {
    src: tamara,
    alt: "Paypal",
    height: "20",
    width: "76",
  },
];

const FooterNew = () => {
  const year = new Date().getFullYear();

  const { datasubcategory } = GetSubcategories();
  const { clearFilters } = useFilterContext();
  const { user, getuserdata } = useAuthContext();

  const { data } = GetFooterlink();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <footer className="ff-footer">
      <div className="ff-topbar" style={{}}>
        <div className="ff-container" style={{ padding: "3rem 16px" }}>
          <h6 className="ff-topbar__left">
            <span className="ff-icon"><LocationOnOutlinedIcon/></span>
            <span>Dubai, United Arab Emirates</span>
          </h6>
          {/* <a href="tel:+971564127900" className="ff-topbar__phone">
            (+971)-5641-27900
          </a>  */}
          <h6 style={{fontWeight:'bolder'}}>
  <a href="tel:(+971)56-412-7900"
   className="ff-topbar__phone" 
    >
    (+971)-5641-27900
  </a>
</h6>

          <h6 className="ff-topbar__right">
            <a
              href="mailto:support@myfamilyfitness.com"
              className="ff-topbar__mail"
            >
              support@myfamilyfitness.com
            </a>
            {Scocialmedia.map((data, index) => (
              <ListItem className="listitems" key={index}>
                <a
                  href={data.link}
                  className="footList"
                  target="_blank"
                  rel="noreferrer"
                >
                  <ListItemIcon className="footlistliwidth" >
                    {data.SocialIcon}
                  </ListItemIcon>

                
                </a>
              </ListItem>
            ))}
          </h6>
        </div>
      </div>

      <div className="ff-main">
        {/* <div className="ff-container ff-grid"> */}
        <div className="foooterCons">
          <Grid container spacing={2} className="footerContainer">
            <Grid item  lg={2.4} md={4} sm={6} xs={12}>
              <img src={logo} className="family_footer_logo" alt="logofooter" />
              <br />
              {Data.map((data, index) => (
                <p className="footerlisttext" id="Family" key={index}>
                  {data.content}
                </p>
              ))}
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div>
                    <div
                      id="DigiCertClickID_9-I-6Txu"
                      style={{ height: "0px" }}
                    ></div>
                    <a href="https://secure.sitelock.com/public/verify/myfamilyfitness.com">
                      <img
                        className="img-responsive"
                        alt="SiteLock"
                        title="SiteLock"
                        src="//shield.sitelock.com/shield/myfamilyfitness.com"
                      />
                    </a>
                  </div>
                </Grid>
                <Grid item xs={6} sx={{ margin: "auto" }}>
                  <a href="https://discovery.ariba.com/profile/AN11078096687">
                    <img
                      alt="View Family Active Sports Equipment Trading LLC profile on SAP Business Network Discovery"
                      border="0"
                      src="https://service.ariba.com/an/p/Ariba/badge_180x55.jpg"
                      width="85%"
                    />
                  </a>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={2.4} md={4} sm={6} xs={12}>
              <List>
                <ListItem sx={{ pl: 0 }}>
                  <h5 className="footheader">Contact</h5>
                </ListItem>

                {Address.map((data, index) => (
                  <ListItem className="listitems" key={index}>
                    <ListItemText className="list_text">
                      <span
                        className="footerlisttext"
                        id={data.id}
                        style={{ color: "#fff" }}
                      >
                        {data.addresstxt}
                      </span>
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            </Grid>

               <Grid item lg={2.4} md={4} sm={6} xs={12}>
                 <List>
                              <ListItem sx={{ pl: 0 }}>
                                <h5 className="footheader">Social</h5>
                              </ListItem>
                
                           
                              {Scocialmedia.map((data,index) => (
                                <ListItem className="listitems" key={index}>
                                  <ListItemIcon className="footlistliwidth" sx={{color:"#fff"}}>
                                    {data.SocialIcon}
                                  </ListItemIcon>
                                  <a
                                    href={data.link}
                                    className="footList"
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <ListItemText className="list_text" sx={{color:"#fff"}}>
                                      <span className="footerlisttext">{data.socaltxt}</span>
                                    </ListItemText>
                                  </a>
                                </ListItem>
                              ))}
                            </List>
               </Grid>

            <Grid item lg={2.4}   md={4} sm={6} xs={12}>
              <List>
                <ListItem sx={{ pl: 0 }}>
                  <h5 className="footheader">Categories</h5>
                </ListItem>
                {datasubcategory &&
                  datasubcategory.map((post) => {
                    return (
                      <ListItem className="listitems" key={post.id}>
                        <Link
                          to={`/category/${post.slug}`}
                          state={{
                            category_id: post.id,
                            banner_image: post.banner_image,
                          }}
                          className="link_style_Footer"
                          onClick={clearFilters}
                        >
                          <span
                            className="footerlisttext"
                            style={{ color: "#fff" }}
                          >
                            {post.name}
                          </span>
                        </Link>
                      </ListItem>
                    );
                  })}
              </List>
            </Grid>
            <Grid item lg={2.4}   md={4} sm={6} xs={12}>
              <List>
                <ListItem sx={{ pl: 0 }}>
                  <h5 className="footheader">About</h5>
                </ListItem>

                {data &&
                  data.map((curElem) => {
                    return (
                      <ListItem className="listitems" key={curElem.id}>
                        <ListItemText className="list_text">
                          <Link
                            to={`/page/${curElem.slug}`}
                            state={{
                              slug: curElem.slug,
                            }}
                            className="link_style_Footer"
                          >
                            {" "}
                            <span
                              className="footerlisttext"
                              style={{ color: "#fff" }}
                            >
                              {curElem.title}
                            </span>
                          </Link>
                        </ListItemText>
                      </ListItem>
                    );
                  })}
              </List>
            </Grid>
          
          </Grid>
        </div>
      
      </div>

      {!matches ? (
        <div className="last__footer">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "16px",
                  textAlign: "left",
                }}
              >
                <p
                  className="footerlisttext"
                  style={{ color: "rgb(207, 211, 214)" }}
                >
                  Copyright © 2026{" "}
                  <span id="footer_myfamily_bold" style={{ color: "#fff" }}>
                    My Family Fitness
                  </span>{" "}
                  all rights reserved. Powered by
                  <a
                    href="https://www.vedaham.xyz/"
                    target="_blank"
                    className="link_style_Footer"
                    rel="noreferrer"
                    style={{ color: "rgb(207, 211, 214)" }}
                  >
                    {" "}
                    VBS
                  </a>{" "}
                </p>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "16px",
                  textAlign: "left",
                }}
              >
                {PayIcon.map((data, index) => (
                  <img
                    src={data.src}
                    alt={data.alt}
                    height={data.height}
                    width={data.width}
                    key={index}
                  />
                ))}
              </Grid>
            </Grid>

            <Grid item xs={2}>
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "16px",
                  textAlign: "left",
                }}
              >
                <div
                  className="scrolltop"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  Scroll to top <StraightIcon />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div className="last__footer">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "16px",
                  textAlign: "center",
                }}
              >
                <p className="footerlisttext">
                  Copyright © 2026{" "}
                  <span id="footer_myfamily_bold">My Family Fitness</span> all
                  rights reserved. Powered by{" "}
                  <a
                    href="https://www.vedaham.xyz/"
                    target="_blank"
                    className="link_style_Footer"
                    rel="noreferrer"
                  >
                    VBS
                  </a>{" "}
                </p>

                <div
                  className="scrolltop"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  Scroll to top <StraightIcon />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </footer>
  );
};

export default FooterNew;
